import {} from "../definition/index.js";
import {} from "./Mod.js";
export function define(mod, name, definition) {
    const found = mod.definitions.get(name);
    if (found !== undefined) {
        throw new Error(`[define] Can not redefine name: ${name}`);
    }
    mod.definitions.set(name, definition);
}
//# sourceMappingURL=define.js.map